import React, { PropsWithChildren } from "react";
import { observer } from "mobx-react";
import { convertCssStringToCssProperties } from "../../util/css/convertCssStringToCssProperties";

interface ISourceLogoComponent {
    logo: string;
    logoStyle?: string | null;
    description?: string | null;
    extraClass?: string | null;
}

@observer
export class SourceLogoComponent extends React.Component<PropsWithChildren<ISourceLogoComponent>> {

    render() {
        const { props } = this;
        const { logo, logoStyle, description, extraClass } = props;
        
        return (
            <img className={ "source-logo " + (extraClass ?? "") } 
                 src={ logo } 
                 alt={ description ?? "" }
                 style={ convertCssStringToCssProperties(logoStyle) }
            />
        );
    }
}
